/**
 * Importo di una sessione nella valuta originale e il suo controvalore in EUR.
 *
 * Oggi la piattaforma è solo EUR (checkout Stripe in 'eur', wallet in EUR),
 * quindi il convertito coincide con l'originale. Se in futuro una sessione
 * avesse un'altra valuta, il controvalore usa SOLO il cambio salvato sulla
 * sessione al momento della transazione (amountEur o exchangeRate): mai un
 * cambio odierno. Senza cambio salvato → null ("—").
 */
export interface SessionAmountInput {
  totalCost: number;
  currency?: string | null;
  exchangeRate?: number | null;
  amountEur?: number | null;
}

export interface SessionAmount {
  amount: number;
  currency: string;
  isEur: boolean;
  amountEur: number | null;
  exchangeRate: number | null;
}

export function sessionAmount(s: SessionAmountInput): SessionAmount {
  const currency = (s.currency || 'EUR').toUpperCase();
  const isEur = currency === 'EUR';
  let amountEur: number | null;
  if (isEur) amountEur = s.totalCost;
  else if (typeof s.amountEur === 'number') amountEur = s.amountEur;
  else if (typeof s.exchangeRate === 'number' && s.exchangeRate > 0) {
    amountEur = Math.round(s.totalCost * s.exchangeRate * 100) / 100;
  } else amountEur = null;
  return {
    amount: s.totalCost,
    currency,
    isEur,
    amountEur,
    exchangeRate: isEur ? 1 : (s.exchangeRate ?? null),
  };
}

export function formatMoney(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency }).format(amount);
  } catch {
    // Codice valuta non valido per Intl: mostra il numero con il codice.
    return `${amount.toFixed(2)} ${currency}`;
  }
}
